export var MessageKey;
(function (MessageKey) {
    MessageKey["accountAlreadyConfirmed"] = "accountAlreadyConfirmed";
    MessageKey["accountAlreadyExists"] = "accountAlreadyExists";
    MessageKey["accountConfirmed"] = "accountConfirmed";
    MessageKey["accountCreated"] = "accountCreated";
    MessageKey["accountData"] = "accountData";
    MessageKey["accountNotConfirmed"] = "accountNotConfirmed";
    MessageKey["accountNotFound"] = "accountNotFound";
    MessageKey["accountPendingConfirmation"] = "accountPendingConfirmation";
    MessageKey["confirmationEmailSent"] = "confirmationEmailSent";
    MessageKey["confirmationTooSoon"] = "confirmationTooSoon";
    MessageKey["confirmationTryAfterMinutes"] = "confirmationTryAfterMinutes";
    MessageKey["healthOk"] = "healthOk";
    MessageKey["incorrectOldPassword"] = "incorrectOldPassword";
    MessageKey["internalServerError"] = "internalServerError";
    MessageKey["invalidCredentials"] = "invalidCredentials";
    MessageKey["invalidEmail"] = "invalidEmail";
    MessageKey["loginSuccessful"] = "loginSuccessful";
    MessageKey["logoutSuccessful"] = "logoutSuccessful";
    MessageKey["notAuthenticated"] = "notAuthenticated";
    MessageKey["passwordChanged"] = "passwordChanged";
    MessageKey["passwordReset"] = "passwordReset";
    MessageKey["resetEmailSent"] = "resetEmailSent";
    MessageKey["resetTokenInvalid"] = "resetTokenInvalid";
    MessageKey["resetTokenMissing"] = "resetTokenMissing";
    MessageKey["resetTooSoon"] = "resetTooSoon";
    MessageKey["routeNotFound"] = "routeNotFound";
    MessageKey["sessionInvalid"] = "sessionInvalid";
    MessageKey["tokenMismatch"] = "tokenMismatch";
    MessageKey["tokenNotFound"] = "tokenNotFound";
    MessageKey["invalidTurnstileToken"] = "invalidTurnstileToken";
    MessageKey["missingTurnstileToken"] = "missingTurnstileToken";
    MessageKey["turnstileVerificationFailed"] = "turnstileVerificationFailed";
    MessageKey["accountPreferences"] = "accountPreferences";
    MessageKey["accountPreferencesUpdated"] = "accountPreferencesUpdated";
    MessageKey["accountProfileUpdated"] = "accountProfileUpdated";
    MessageKey["forbiddenOrigin"] = "forbiddenOrigin";
    MessageKey["forbiddenOriginSecret"] = "forbiddenOriginSecret";
})(MessageKey || (MessageKey = {}));
//# sourceMappingURL=message-key.js.map